<div class="relative inline-block">
  <div class="mb-1 flex flex-col">
    <span class="text-[16px] font-regular text-black">{{ label }}</span>
    <!-- <span class="text-[16px] text-neutral-dark">Fto: dd-mm-aaaa (dia-mes-año)</span> -->
  </div>
  <p-floatlabel class="custonLabel">
    <p-datepicker
      [(ngModel)]="selectedDate"
      (ngModelChange)="onDateChanged($event)"
      (onBlur)="onBlur()"
      [showButtonBar]="showButtonBar"
      [inline]="inline"
      [showWeek]="showWeek"
      [showIcon]="'pi pi-calendar'"
      [iconDisplay]="'input'"
      [locale]="localeEs"
      class="customClass"
      [ngClass]="[sizeClass, type === 'range' ? 'datepicker-range' : '']"
      [placeholder]="placeholder"
      [selectionMode]="type"
      [minDate]="minDate"
      [keepInvalid]="keepInvalid"
      [readonlyInput]="true"
      inputId="over_label" />
  </p-floatlabel>
  <button
    *ngIf="selectedDate"
    (click)="clearSelection()"
    class="absolute top-3 right-2 bg-gray-100 rounded-full px-1 py-0.5 text-xs hover:bg-red-100"
    title="Limpiar selección">
    ✕
  </button>
</div>
